export default "__VITE_ASSET__DA3$YoCj__"